// extracted by mini-css-extract-plugin
export default {"suggestions-wrapper-header":"SuggestionsWrapper_suggestions-wrapper-header__GVX+d","suggestions-wrapper-list":"SuggestionsWrapper_suggestions-wrapper-list__qtirC"};